import Vue from 'vue';
import Router from 'vue-router';
import layout from '@/layout/layout';
import index from '@/pages/index';
import announcementList from '@/pages/announcementList';
import loginLayout from '@/layout/loginLayout';

const login = () => import('@/pages/login');
const announcementLayout = () => import('@/layout/announcementLayout');
const announcementDetail = () => import('@/pages/announcementDetail');
const consultLayout = () => import('@/layout/consultLayout');
const consultList = () => import('@/pages/consultList');
const planner = () => import('@/pages/planner');
const posted = () => import('@/pages/posted');
const assessLayout = () => import('@/layout/assessLayout');
const assessTabLayout = () => import('@/layout/assessTabLayout');
const assessAll = () => import('@/pages/assessAll');
const assessNo = () => import('@/pages/assessNo');
const assessDone = () => import('@/pages/assessDone');
const assessProceed = () => import('@/pages/assessProceed');
const exam = () => import('@/pages/exam');
const consultDetail = () => import('@/pages/consultDetail');
const changePwd = () => import('@/pages/changePwd');
const abilityLayout = () => import('@/layout/abilityLayout');
const abilityList = () => import('@/pages/abilityList');
const videoList = () => import('@/pages/videoList');
const videoDetails = () => import('@/pages/videoDetails');
const videoLayout = () => import('@/layout/videoLayout');
const result = () => import('@/pages/result');

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '*',
      redirect () {
        return '/';
      }
    },
    {
      path: '/',
      name: 'layout',
      component: layout,
      redirect: {
        path: 'index'
      },
      children: [
        {
          path: 'index',
          name: 'index',
          component: index
        },
        {
          path: 'announcement',
          name: 'announcement',
          component: announcementLayout,
          redirect: {
            name: 'announcementList'
          },
          children: [
            {
              path: 'announcementList',
              name: 'announcementList',
              component: announcementList
            },
            {
              path: 'announcementDetail',
              name: 'announcementDetail',
              component: announcementDetail
            }
          ]
        },
        {
          path: 'consult',
          name: 'consult',
          component: consultLayout,
          redirect: {
            name: 'consultList'
          },
          children: [
            {
              path: 'consultList',
              name: 'consultList',
              component: consultList,
              redirect: {
                name: 'posted'
              },
              children: [
                {
                  path: 'posted',
                  name: 'posted',
                  component: posted
                },
                {
                  path: 'planner',
                  name: 'planner',
                  component: planner
                }
              ]
            },
            {
              path: 'consultDetail',
              name: 'consultDetail',
              component: consultDetail
            }
          ]
        },
        {
          path: 'assessLayout',
          name: 'assessLayout',
          component: assessLayout,
          redirect: {
            name: 'assessTabLayout'
          },
          children: [
            {
              path: 'assessTabLayout',
              name: 'assessTabLayout',
              component: assessTabLayout,
              redirect: {
                name: 'assessAll'
              },
              children: [
                {
                  path: 'assessAll',
                  name: 'assessAll',
                  component: assessAll
                },
                {
                  path: 'assessNo',
                  name: 'assessNo',
                  component: assessNo
                },
                {
                  path: 'assessDone',
                  name: 'assessDone',
                  component: assessDone
                },
                {
                  path: 'assessProceed',
                  name: 'assessProceed',
                  component: assessProceed
                }
              ]
            },
            {
              path: 'exam',
              name: 'exam',
              component: exam
            }
          ]
        },
        {
          path: 'abilityLayout',
          name: 'abilityLayout',
          component: abilityLayout,
          redirect: {
            name: 'abilityList'
          },
          children: [
            {
              path: 'abilityList',
              name: 'abilityList',
              component: abilityList
            }
          ]
        },
        {
          path: 'videoLayout',
          name: 'videoLayout',
          component: videoLayout,
          redirect: {
            name: 'videoList'
          },
          children: [
            {
              path: 'videoList',
              name: 'videoList',
              component: videoList
            },
            {
              path: 'videoDetails',
              name: 'videoDetails',
              component: videoDetails
            }
          ]
        }
      ]
    },
    {
      path: '/loginLayout',
      component: loginLayout,
      name: 'loginLayout',
      redirect: '/login',
      children: [
        {
          path: '/login',
          name: 'login',
          component: login
        },
        {
          path: '/changePwd',
          name: 'changePwd',
          component: changePwd
        }
      ]
    },
    {
      path: '/result',
      component: result,
      name: 'result'
    }
  ],
  mode: 'hash'
});



// WEBPACK FOOTER //
// ./src/router/index.js